module.exports = __webpack_public_path__ + "img/1594892449.bd7fe020.jpg";